const TeamData = [
  {
    name: "Ashish Kumar",
    position: "President",
    image: "img/team/ashish.jpg",
    linkedin: "https://www.linkedin.com/in/ashishkiitkgp/",
    facebook: "https://www.facebook.com/profile.php?id=100009722254419",
    instagram: "https://www.instagram.com/ashish_kumar_iitkgp/",
  },
  {
    name: "Adesh Ghadage",
    position: "Vice-President",
    image: "img/team/adesh.jpg",
    linkedin: "https://in.linkedin.com/in/adeshghadage",
    facebook: "https://www.facebook.com/adesh.ghadage.96/",
    instagram: "https://www.instagram.com/adesh_ghadage/",
  },
  {
    name: "Praneetha Pedapudi",
    position: "Advisor",
    image: "img/team/praneetha.jpg",
    linkedin: "https://www.linkedin.com/in/praneetha-pedapudi-0b1b36223/",
    facebook: "https://www.facebook.com/profile.php?id=100008124998396",
    instagram: "https://www.instagram.com/_pranee_tha_/",
  },

  {
    name: "Anushika Srivastava",
    position: "General Secretary",
    image: "img/team/anushika.jpg",
    linkedin: "https://www.linkedin.com/in/anushika-srivastava-05ab90256/",
    facebook: "https://www.facebook.com/anushika.shrivastava.102",
    instagram: "https://www.instagram.com/_anushika_06_/",
  },

  {
    name: "Karamtoth Goutham Nayak",
    position: "General Secretary",
    image: "img/team/gouthamn.jpg",
    linkedin: "https://www.linkedin.com/in/gouthamiitkgp9/",
    facebook: "https://www.facebook.com/profile.php?id=100087708483886",
    instagram: "https://www.instagram.com/gouthamxt/",
  },

  {
    name: "Potala Karthik Naidu",
    position: "General Secretary",
    image: "img/team/karthik.jpg",
    linkedin:
      "https://www.linkedin.com/in/karthik-naidu-20a88626a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    facebook:
      "https://www.facebook.com/potalakarthiknaidu.potalakarthiknaidu.7?mibextid=LQQJ4d",
    instagram: "https://www.instagram.com/_krtk.__/",
  },

  {
    name: "Dipesh Goel",
    position: "Sponsorship Head",
    image: "img/team/dipesh.jpg",
    linkedin: "https://www.linkedin.com/in/dipeshgoel27/",
    facebook: "https://www.facebook.com/dipeshgoel27",
    instagram: "https://www.instagram.com/dipeshgoel27",
  },

  {
    name: "Satyam Jayswal",
    position: "Events Head",
    image: "img/team/satyam.jpg",
    linkedin: "https://www.linkedin.com/in/satyam-jayswal-14539a25b/",
    facebook: "https://www.facebook.com/profile.php?id=61561169904097",
    instagram: "",
  },
  {
    name: "Gunashiyaa Elangovan ",
    position: "Events Head",
    image: "img/team/gunashiyaa.jpg",
    linkedin: "https://www.linkedin.com/in/gunashiyaa-elangovan-73027b288/",
    facebook: "https://www.facebook.com/profile.php?id=100087417407869",
    instagram: "https://www.instagram.com/gunashiyaa_02/",
  },

  {
    name: "Eshwar Naik ",
    position: "PR Head",
    image: "img/team/eshwarn.jpg",
    linkedin: "https://www.linkedin.com/in/eshwarnaikb?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    facebook: "https://www.facebook.com/profile.php?id=100087757410046&mibextid=ZbWKwL",
    instagram: "https://www.instagram.com/eshwar.xt/",
  },


  {
    name: "Srestha Gajula",
    position: "Design Head",
    image: "img/team/shreshta.jpg",
    linkedin: "",
    facebook: "",
    instagram: "",
  },

  {
    name: "Pranit Chaudhary",
    position: "Web Sub-Head",
    image: "img/team/pranit.jpg",
    linkedin: "https://www.linkedin.com/in/pranit-chaudhary-b414b8286/",
    facebook: "https://www.facebook.com/profile.php?id=61551658334926",
    instagram: "https://www.instagram.com/pranit_1024/",
  },
  {
    name: "Ankit Pal",
    position: "Web Sub-Head",
    image: "img/team/ankit.jpg",
    linkedin: "https://www.linkedin.com/in/ankit-pal-59b398286/",
    facebook: "",
    instagram: "",
  },

  {
    name: "Namanya Pant",
    position: "Web Sub-Head",
    image: "img/team/namanya.jpg",
    linkedin: "https://www.linkedin.com/in/namanya-pant-76899b2b0/",
    facebook: "facebook.com/profile.php?id=61557729866848",
    instagram: "https://www.instagram.com/namanya_1239/",
  },

  {
    name: "Toni blair",
    position: "Design Sub-Head",
    image: "img/team/toni.jpg",
    linkedin: "https://www.linkedin.com/in/toni-blair-a61b57297/",
    facebook: "",
    instagram: "",
  },

  {
    name: "Harsh Rai",
    position: "Core Sub-Head",
    image: "img/team/harsh.jpg",
    linkedin: "https://www.linkedin.com/in/harsh-rai-18525618b/",
    facebook: "https://www.facebook.com/profile.php?id=100029291851467",
    instagram: "",
  },
];

export default TeamData;
